import { Component, OnDestroy, OnInit } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { ActivatedRoute, Router } from '@angular/router'
import { EVENT_NAMES } from '../../utils/events'
import type { SaveTaxResidenceResponse } from '../../interfaces/save-tax-residence-response'

@Component({
  selector: 'app-fiscal-layout',
  templateUrl: './fiscal-layout.component.html',
  styleUrls: ['./fiscal-layout.component.scss'],
})
export class FiscalLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  flow!: string
  process!: string
  clientRoute!: string

  constructor(private router: Router, private route: ActivatedRoute) {
    this.flow = this.router.url.split('/')[1]
    this.process = this.router.url.split('/')[2]
    this.clientRoute = this.router.url.split('/')[3]
  }

  private handleNavigateToOtp = () => {
    this.router.navigate(['..', 'otp'], { relativeTo: this.route, replaceUrl: true })
  }

  private handleOnExit = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  private handleOnBack = () => {
    const isMigrant = this.flow === 'migrante'
    const isFlexible = this.flow === 'flexible'
    const isTransactional = this.flow === 'transaccional'

    if (this.clientRoute === 'cliente') {
      if (isTransactional) this.router.navigate([this.flow, this.process], { replaceUrl: true })
      if (isFlexible)
        this.router.navigate(['..', 'simulacion'], { relativeTo: this.route, replaceUrl: true })
    } else if (isMigrant) {
      this.router.navigate(['..', 'firc', '4'], { relativeTo: this.route, replaceUrl: true })
    } else {
      this.router.navigate(['..', 'firc', '3'], { relativeTo: this.route, replaceUrl: true })
    }
  }

  ngOnInit(): void {
    const fircData = this.storage.get(EVENT_NAMES.fircOnChange) || {
      contactData: {},
      addressData: {},
      workData: {},
    }

    this.storage.set(EVENT_NAMES.taxResidenceConfig, { showTermsAndConditions: true, fircData })
    window.addEventListener(EVENT_NAMES.taxResidenceOnBack, this.handleOnExit)
    window.addEventListener(EVENT_NAMES.taxResidenceOnBackStep, this.handleOnBack)
    window.addEventListener(EVENT_NAMES.taxResidenceOnNextStep, this.handleNavigateToOtp)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.taxResidenceOnBack, this.handleOnExit)
    window.removeEventListener(EVENT_NAMES.taxResidenceOnBackStep, this.handleOnBack)
    window.removeEventListener(EVENT_NAMES.taxResidenceOnNextStep, this.handleNavigateToOtp)
  }
}
